import React from 'react'

export default function Image(props) {
    return (
        <img src={props.src} width="90%" height="90%" alt="Compare INSTAR Camera Models" />
    )
}
